import React from 'react';
import { colors } from '../../../../../../../colorVars';
import { Body3 } from '../../../../../../atomic/text/Text';
import style from './IndividualTacticStyle.module.css';

export const IndividualPanelHeader = () => {
  return (
    <thead>
      <tr style={{ backgroundColor: colors.grey }}>
        <th className={style.fieldHeader}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Field
          </Body3>
        </th>
        <th className={style.valueHeader}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Value
          </Body3>
        </th>
        <th className={style.fieldHeader}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Field
          </Body3>
        </th>
        <th className={style.valueHeader}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Value
          </Body3>
        </th>
      </tr>
    </thead>
  );
};
